import { Component, OnInit, Inject     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';
import { User                          } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { SlotModelAuto } from 'src/app/beans/slot-model/slot-model.auto.bean';
import { SlotModel } from 'src/app/beans/slot-model/slot-model.bean';
import { Organization } from 'src/app/beans/organization/organization.bean';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';

@Component
({
  selector: 'slot.model.apply.dialog',
  templateUrl: './slot.model.apply.dialog.html',
  styleUrls: ['./slot.model.apply.dialog.scss'],
})

export class ModelApplyDialog implements OnInit 
{

  today: Date = new Date()

  param : any

  models : SlotModel[]
  
  constructor
  (
    private dialogRef : MatDialogRef<ModelApplyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    
    private _handler : HandlerManager,
    private _loader  : LoadingManager,
    private _session : SessionManager,
    private _utils   : UtilsManager,
    private _notifier: NotifierManager
  ) {}

  ngOnInit(): void
  {
    
    this.init()
  }

  async init()
  {
    this.param = this.data
    this.param.dateFrom = this.today
    this.param.dateTo = this.today
    this.param.delete = 1
    this.getModels()
  }

  async getModels()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null

    response = await this._handler.slotModel().list((user as User).token, this.param.siteId)

    this._loader.stop()

    this.models = response.list as SlotModel[];

  }

  checkDate()
  {
    this.param.dateFrom = this.param.dateFrom < this.today ? this.today : this.param.dateFrom
    this.param.dateTo = this.param.dateTo < this.param.dateFrom ? this.param.dateFrom : this.param.dateTo
  }
  //----------------------------------------------------------------------------------

  cancel()
  {
    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  apply()
  {
    if(this.param.serviceId == undefined || this.param.model == undefined ){
      this._notifier.show
      ( 
        Notifier.WARNING            , 
        NotifierMessage.GENERIC_MISSING_PARAM
      )
      return
    }

    this.param.dateFrom = this._utils.date().toFormat(this.param.dateFrom, "yyyy-MM-dd", null)
    this.param.dateTo = this._utils.date().toFormat(this.param.dateTo, "yyyy-MM-dd", null)

    this.dialogRef.close
    ( 
      {
        code: DialogsReturnCode.SLOTMODEL_MODEL,
        param : 
        {
          dF: this.param.dateFrom,
          dT: this.param.dateTo,
          s: this.param.serviceId,
          m: this.param.model,
          h: this.param.holiday ? 1:0,
          d: this.param.delete ? 1:0
        }
      }
    )
  }

}